import { useState, useEffect } from "react";
import { DataContext } from "contexts/DataContext";
import { setAuthToken } from "utils/setAuthToken";
import { getProfile } from "utils/api";
import Cookies from "js-cookie";
import { get as getOrganizationList } from "pages/Organization/api";
import { get as getAssessmentList } from "pages/Assessment/api";
import { getMaturities, getCoverages } from "components/AssessmentControl/api";
//import { useNavigate } from "react-router-dom";
import i18next from "i18next";

interface Props {
  children: React.ReactNode;
}

export default function DataContextWrapper(props: Props) {
  const [language, setLanguage] = useState('en');
  const [user, setUser] = useState({} as any);
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(true);
  const [reloadParent, setReloadParent] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [organizationList, setOrganizationList] = useState([]);
  const [assessmentList, setAssessmentList] = useState([]);
  const [currentOrganization, setCurrentOrganization] = useState('');
  const [currentAssessment, setCurrentAssessment] = useState('');
  const [currentControl, setCurrentControl] = useState('');
  const [maturities, setMaturities] = useState([] as any);
  const [coverages, setCoverages] = useState([] as any);
  const [darkMode, setDarkMode] = useState(false);
  //const navigate = useNavigate();
  function changeLanguage(language:string) {
    setLanguage(language);
    localStorage.setItem('language', language);
    i18next.changeLanguage(language);
  }
  function changeUser(user:any) {
    setUser(user);
  }
  function changeToken(token:any) {
    setToken(token);
    setAuthToken(token);
    Cookies.set('jwt',token);
    if(!token) {
      localStorage.setItem('currentOrganization', '');
      localStorage.setItem('currentAssessment', '');
    }
  }
  function toggleReloadParent() {
    setReloadParent(!reloadParent);
  }
  function changeShowLoader(loader:any) {
    setShowLoader(loader);
  }
  function changeOrganizationList(list:any) {
    setOrganizationList(list);
  }
  function changeAssessmentList(list:any) {
    setAssessmentList(list);
  }
  function changeCurrentOrganization(organization:any) {
    if(!organization) {
      localStorage.removeItem("currentOrganization");      
    } else {
      localStorage.setItem("currentOrganization", organization);
    }
    setCurrentOrganization(organization);
    //if(currentOrganization) {
    //  navigate('/tenant-executive-view', {replace: true});
    //}
  }
  function changeCurrentAssessment(assessment:any) {
    if(!assessment) {
      localStorage.removeItem("currentAssessment");
    } else{
      localStorage.setItem("currentAssessment", assessment);
    }
    setCurrentAssessment(assessment);
  }

  function changeCurrentControl(control:any) {
    if(!control) {
      localStorage.removeItem("currentControl");
    } else {
      localStorage.setItem("currentControl", JSON.stringify(control));
    }
    setCurrentControl(control);
  }

  function changeDarkMode(dark:boolean) {
    setDarkMode(dark);
    localStorage.setItem('darkMode', dark ? 'true' : 'false');
  }


  useEffect(()=>{
      changeToken(Cookies.get("jwt"));
      if(localStorage.getItem("user")) {
        try {
          changeUser(JSON.parse(localStorage.getItem("user") || '{}'));
        } catch(e) {
          changeUser({});
        }
      }
      if(localStorage.getItem("language")) {
        changeLanguage(localStorage.getItem("language") || 'en');
      } else {
        changeLanguage('en');
      }
      if(localStorage.getItem("darkMode")) {
        changeDarkMode(localStorage.getItem("darkMode") === 'true');
      }
      if(localStorage.getItem("currentControl")) {
        try {
          changeCurrentControl(JSON.parse(localStorage.getItem("currentControl")||'{}'));
        } catch(e) {
          changeCurrentControl({});
        }
      }
      if(token) {
        getProfile().then(user => {
          changeUser(user);
        });
      }
      setLoading(false);
  },[token]);

  useEffect(()=>{
    if(!token) return;
    getMaturities().then((response) => {
      setMaturities(response);
    });
    getCoverages().then((response) => {
      setCoverages(response);
    });
  },[token]);

  useEffect(()=>{
    if(!token) return;
    getOrganizationList().then((response) => {
      changeOrganizationList(response);
      changeCurrentOrganization(localStorage.getItem("currentOrganization") || '');
    });
    // eslint-disable-next-line
  },[token, reloadParent]);

  useEffect(()=>{
    if(!currentOrganization) return;
    getAssessmentList().then((response) => {
      changeAssessmentList(response);
      let currentAssessment = localStorage.getItem("currentAssessment") || '';
      // eslint-disable-next-line
      if(response && response.filter((assessment:any) => assessment.id==currentAssessment).length) {
        changeCurrentAssessment(localStorage.getItem("currentAssessment") || '');
      } else {
        changeCurrentAssessment('');
      }
    });
  },[currentOrganization, reloadParent]);

  return (
    <DataContext.Provider value={{
      user: user, 
      changeUser: changeUser,
      token: token, 
      changeToken: changeToken,
      loading: loading,
      toggleReloadParent: toggleReloadParent,
      reloadParent: reloadParent,
      showLoader: showLoader, 
      changeShowLoader: changeShowLoader,
      organizationList: organizationList,
      changeOrganizationList: changeOrganizationList,
      currentOrganization: currentOrganization,
      changeCurrentOrganization: changeCurrentOrganization,
      assessmentList: assessmentList,
      changeAssessmentList: changeAssessmentList,
      currentAssessment: currentAssessment,
      changeCurrentAssessment: changeCurrentAssessment,
      currentControl: currentControl,
      changeCurrentControl: changeCurrentControl,
      language: language,
      changeLanguage: changeLanguage,
      maturities: maturities,
      coverages: coverages,
      darkMode: darkMode,
      changeDarkMode: changeDarkMode,
    }}>
      {props.children}
    </DataContext.Provider>
  );
}